import { PermissionSetType } from '../sets'
import { AppPermissionSet } from '../sets/AppPermissions'
import { WebhookPermissionSet } from '../sets/WebhookPermissions'
import { WorkflowPermissionSet } from '../sets/WorkflowPermissions'
import { AdminMinimalRole } from './AdminMinimalRole'
import { OperationsManagerRole } from './OperationsManagerRole'
import { ServicePlannerRole } from './ServicePlannerRole'

export const DeveloperRole: PermissionSetType[] = [
  ...OperationsManagerRole,
  ...ServicePlannerRole,
  ...AdminMinimalRole,

  AppPermissionSet.View,
  AppPermissionSet.Manage,
  AppPermissionSet.AppInstallationView,
  AppPermissionSet.AppInstallationManage,
  WorkflowPermissionSet.View,
  WorkflowPermissionSet.Write,
  WorkflowPermissionSet.Delete,
  WebhookPermissionSet.View,
  WebhookPermissionSet.Write,
]
